import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDateForDB } from '../../../utils/dateUtils';

const StatsOverview = ({ appointments = [] }) => {
  const today = formatDateForDB(new Date());
  const todayAppointments = appointments?.filter(apt => apt?.date === today);
  
  const totalSlots = 48;
  const bookedSlots = appointments?.length;
  const availableSlots = totalSlots - bookedSlots;
  const utilizationRate = Math.round((bookedSlots / totalSlots) * 100);

  const stats = [
    {
      label: 'Today\'s Bookings',
      value: todayAppointments?.length,
      icon: 'CalendarCheck',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Total Bookings',
      value: appointments?.length,
      icon: 'Calendar',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Available Slots',
      value: availableSlots,
      icon: 'Clock',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Utilization',
      value: `${utilizationRate}%`,
      icon: 'TrendingUp',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6 px-4 md:px-6 lg:px-8 py-4 md:py-5 lg:py-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="p-4 md:p-5 lg:p-6 bg-card border border-border rounded-lg shadow-elevation-1 hover:shadow-elevation-2 transition-smooth"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-xs md:text-sm text-muted-foreground font-caption">
                {stat?.label}
              </p>
              <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mt-2">
                {stat?.value}
              </p>
            </div>
            <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 ${stat?.bgColor} rounded-lg`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;